interface ProviderUsageResetLabelOptions {
  readonly locale?: string;
  readonly timeZone?: string;
  readonly nowMs?: number;
}

const resetTimestampFormatters = new Map<string, Intl.DateTimeFormat>();

function getResetTimestampFormatter(
  locale: string | undefined,
  timeZone: string | undefined,
): Intl.DateTimeFormat {
  const cacheKey = `${locale ?? "default"}:${timeZone ?? "local"}`;
  const cached = resetTimestampFormatters.get(cacheKey);
  if (cached) return cached;

  const formatter = new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
    timeZone,
  });
  resetTimestampFormatters.set(cacheKey, formatter);
  return formatter;
}

export function formatProviderUsageResetLabel(
  iso: string,
  options: ProviderUsageResetLabelOptions = {},
): string {
  const resetAt = new Date(iso);
  if (Number.isNaN(resetAt.getTime())) return "Reset time unavailable";

  try {
    const timestamp = getResetTimestampFormatter(options.locale, options.timeZone).format(resetAt);
    return `${resetAt.getTime() <= (options.nowMs ?? Date.now()) ? "Reset" : "Resets"} ${timestamp}`;
  } catch {
    return "Reset time unavailable";
  }
}
